<template>
	<header-block title="Accounts" bgcolor="#FCE5D4dd"></header-block>
	<CustomerLoadWait :customer="customer && bankInfo" :cardBlocks="true" />
	<transition>
		<div v-if="customer && bankInfo">

			<div class="balanceHeader">
				Total balance
				<p>{{ formatter.format(Math.round(accountsBalance), false, false) }}</p>
			</div>

			<!-- Parent div to allow odd/even css selectors -->
			<div>
				<div :class="'hubItemWrapper'" v-for="a in accounts" :key="a.id">
					<AccountButton :circleIcon="true" :href="'#/account/' + a.id" :title="a.bankDisplayName" :icon="a.bank.logoPath ? require('@/assets/logos/' + a.bank.logoPath) : require('@/assets/round1.png')" :provider="a.displayName" :balance="formatter.format(Math.round(a.balance))"></AccountButton>
				</div>
			</div>

			<div style="clear:both; padding-bottom: 110px;"></div>

			<DrawerPanel :bottom="_peekingDrawerBottom()" title="Recent Transactions" backgroundColor="white" openBackgroundColor="white">
				<TransactionsList :showDateTotal="true" v-if="bankInfo" search="true" :transactions="bankInfo.recentTransactions" :formatter="formatter" :today="today" :yesterday="yesterday" />
			</DrawerPanel>



		</div>
	</transition>
</template>

<script>
import Services from '../mixins/Services';
import TransactionsList from './elements/TransactionsList.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import AccountButton from './elements/AccountButton.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import Helpers from '../mixins/Helpers';

export default {
	mixins: [Services, Helpers],
	components: { TransactionsList, CustomerLoadWait, AccountButton, HeaderBlock, DrawerPanel },
	data() {
		return {
			section: 'd2d',
			drawerHeight: "82px",
			drawer:false,
			accounts: [],
			accountsBalance: 0,
		}
	},
	methods: {
		toggleTransactions: function() {
			this.drawer = !this.drawer;
			if (!this.drawer)
			{
				this.drawerHeight = "82px";
			}
			else
			{
				this.drawerHeight = "80%";
			}
		},
		getCustomer: function(){
			this._getCustomer(() => {
				
			});
		},
		getBankInfo: function(){
			this._getBankingInfo(() => {
				this.bankInfo.accounts.forEach((a) => 
				{
					if (a.accountType.prettyName == "Current" && this.$route.params.accountType.toLowerCase() == "current")
					{
						this.accounts.push(a);
						this.accountsBalance += a.balance;
					}
					else if (a.accountType.prettyName == "Credit" && this.$route.params.accountType.toLowerCase() == "credit")
					{
						this.accounts.push(a);
						this.accountsBalance += a.balance;
					}
					else if (a.accountType.prettyName == "Savings" && this.$route.params.accountType.toLowerCase() == "savings")
					{
						this.accounts.push(a);
						this.accountsBalance += a.balance;
					}
				});
			});
		},
		onLoad: async function() {
			this.getCustomer();
			this.getBankInfo();
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.balanceHeader {
	background: linear-gradient(202deg, #FCE5D4 49.85%, #E0C5C8 100%);
	height: 45vh;
	clear:both;
	margin-left: -30px;
	margin-right: -30px;
	margin-top: -138px;
	margin-bottom: -70px;
	color: var(--text-color);
	font-size: 15px;
	text-align: center;
	padding-top: 148px;
	p{
		font-size: 48px;
		font-family: 'Gotham-Heavy';
		margin-top: 0px;
	};
}

</style>
